import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import { Link, useNavigate } from 'react-router-dom';
import { addFormData, fetchAllDataAPI } from '../utils/api';
import { toast } from 'react-toastify';
import { FaRegEye, FaFilter, FaRedo } from 'react-icons/fa';
import { CiExport } from "react-icons/ci";
import CsvDownloader from 'react-csv-downloader';
import { numberFormat } from '../components/numberFormat';
import { MdLocalShipping, MdPendingActions, MdNewLabel, MdDoneAll, MdCancel } from "react-icons/md";
import withAuth from '../utils/withAuth';

const STATUS_CONFIG = {
    'Delivered': { color: '#0e7c52', bg: '#e8f5e9' },
    'RTO Delivered': { color: '#597e0d', bg: '#f1f8e9' },
    'In Transit': { color: '#1565c0', bg: '#e3f2fd' },
    'Out For Delivery': { color: '#00838f', bg: '#e0f7fa' },
    'Cancelled': { color: '#c62828', bg: '#ffebee' },
    'Failed Delivery': { color: '#c62828', bg: '#ffebee' },
    'NEW': { color: '#6a1b9a', bg: '#f3e5f5' },
    'Undelivered': { color: '#e65100', bg: '#fff3e0' },
    'Pickup Booked': { color: '#4e9191', bg: '#e0f4f4' },
    'default': { color: '#555', bg: '#f5f5f5' },
};

const CONFIRM_CONFIG = {
    'Confirm': { color: '#0e7c52', bg: '#e8f5e9' },
    'confirm': { color: '#0e7c52', bg: '#e8f5e9' },
    'Confirmed': { color: '#0e7c52', bg: '#e8f5e9' },
    'Abandoned': { color: '#c62828', bg: '#ffebee' },
    'abandoned': { color: '#c62828', bg: '#ffebee' },
    'Pending': { color: '#e65100', bg: '#fff3e0' },
    'default': { color: '#555', bg: '#f5f5f5' },
};

const getStatusStyle = (status) =>
    STATUS_CONFIG[status] || STATUS_CONFIG['default'];

const getConfirmStyle = (status) =>
    CONFIRM_CONFIG[status] || CONFIRM_CONFIG['default'];

const ORDER_TYPES = [
    { key: 'all', label: 'All Orders', icon: <MdLocalShipping />, color: '#4e9191' },
    { key: 'new', label: 'New', icon: <MdNewLabel />, color: '#6a1b9a' },
    { key: 'delivered', label: 'Delivered', icon: <MdDoneAll />, color: '#0e7c52' },
    { key: 'process', label: 'Processing', icon: <MdPendingActions />, color: '#1565c0' },
    { key: 'abandoned', label: 'Abandoned', icon: <MdCancel />, color: '#c62828' },
];

const VENDOR_OPTIONS = [
    'Sat Kartar Shopping',
    'Sat Kartar CO IN',
    'Vedabay',
];

const SkeletonRow = () => (
    <tr>
        {[...Array(17)].map((_, i) => (
            <td key={i}>
                <div style={{
                    height: '14px', borderRadius: '6px',
                    background: 'linear-gradient(90deg,#f0f0f0 25%,#e8e8e8 50%,#f0f0f0 75%)',
                    backgroundSize: '200% 100%',
                    animation: 'shimmer 1.5s infinite'
                }} />
            </td>
        ))}
    </tr>
);

const AllOrders = () => {
    const ref = useRef();
    const [cmsorder, setCmsorder] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [filtervalue, setFilterValue] = useState({});
    const [sstatus, setSStatus] = useState([]);
    const [activeType, setActiveType] = useState('all');
    const [totalCounts, setTotalCounts] = useState({});
    const subagentid = localStorage.getItem('subagentdata');
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const recordPerPage = 100;
    const lastIndex = currentPage * recordPerPage;
    const firstIndex = lastIndex - recordPerPage;
    const records = cmsorder.slice(firstIndex, lastIndex);
    const npage = Math.ceil(cmsorder.length / recordPerPage);
    const numbers = [...Array(npage + 1).keys()].slice(1);

    useEffect(() => {
        if (subagentid) {
            getAllCmsOrders('all');
            getShippingStatus();
            getOrderCounts();
        } else {
            navigate("/");
        }
    }, [subagentid]);

    const getAllCmsOrders = (type = 'all') => {
        setIsLoading(true);
        setActiveType(type);
        fetchAllDataAPI(`sub-agent-get-cms-order-by-type/${type}`)
            .then((res) => {
                if (res?.data?.status === 1) {
                    setCmsorder(res.data.cmsorder || []);
                    setCurrentPage(1);
                } else {
                    setCmsorder([]);
                    toast.warning("No orders found");
                }
            })
            .catch(() => {
                setCmsorder([]);
                toast.error("Failed to load orders");
            })
            .finally(() => setIsLoading(false));
    };

    const getOrderCounts = () => {
        fetchAllDataAPI('sub-agent-get-order-type-counts')
            .then((res) => {
                if (res?.data?.status === 1) setTotalCounts(res.data.counts);
            })
            .catch(() => { });
    };

    const getShippingStatus = () => {
        setSStatus([
            { status_name: 'NEW' },
            { status_name: 'Pickup Booked' },
            { status_name: 'Pickup Generated' },
            { status_name: 'Picklist Generated' },
            { status_name: 'PICKUP SCHEDULED' },
            { status_name: 'Out For Pickup' },
            { status_name: 'Pickup Rescheduled' },
            { status_name: 'Pickup Exception' },
            { status_name: 'Box Packing' },
            { status_name: 'Ready To Pack' },
            { status_name: 'In Flight' },
            { status_name: 'In Transit' },
            { status_name: 'Out For Delivery' },
            { status_name: 'Delivered' },
            { status_name: 'Undelivered' },
            { status_name: 'Failed Delivery' },
            { status_name: 'Delayed' },
            { status_name: 'RTO Initiated' },
            { status_name: 'RTO Acknowledged' },
            { status_name: 'RTO Delivered' },
            { status_name: 'Cancelled' },
            { status_name: 'QC FAILED' },
            { status_name: 'Pickup Error' },
        ]);
    };

    const handleFilter = (e) => {
        e.preventDefault();
        if (filtervalue && Object.keys(filtervalue).length > 0) {
            setIsLoading(true);
            addFormData('sub-agent-filter-order-data', { ...filtervalue, order_type: activeType })
                .then((res) => {
                    if (res?.data?.status === 1) {
                        setCmsorder(res.data.filterdata);
                        setCurrentPage(1);
                    }
                })
                .catch(() => toast.error("Filter failed"))
                .finally(() => setIsLoading(false));
        } else {
            getAllCmsOrders(activeType);
        }
    };

    const resetOrder = () => {
        ref.current.reset();
        setFilterValue({});
        getAllCmsOrders(activeType);
    };

    const handleInputs = (e) => {
        setFilterValue({ ...filtervalue, [e.target.name]: e.target.value });
    };

    const columns = [
        { id: 'order_number', displayName: 'Order No.' },
        { id: 'cust_name', displayName: 'Name' },
        { id: 'cust_phone', displayName: 'Mobile' },
        { id: 'subtotal_price', displayName: 'Total Price' },
        { id: 'created_date', displayName: 'Order Date' },
        { id: 'created_time', displayName: 'Order Time' },
        { id: 'state', displayName: 'State' },
        { id: 'city', displayName: 'City' },
        { id: 'pincode', displayName: 'Pincode' },
        { id: 'vendor_name', displayName: 'Platform Name' },
        { id: 'shipingid', displayName: 'Shipping ID' },
        { id: 'awb_number', displayName: 'AWB ID' },
        { id: 'shipment_status', displayName: 'Shipment Status' },
        { id: 'payment_method', displayName: 'Payment Method' },
    ];

    return (
        <div className="misDashboard">
            <Helmet><title>SATKARTAR:SUB AGENT::ALL ORDERS</title></Helmet>

            <style>{`
                @keyframes shimmer {
                    0%   { background-position: 200% 0; }
                    100% { background-position: -200% 0; }
                }
                @keyframes fadeInUp {
                    from { opacity: 0; transform: translateY(16px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                .order-page { animation: fadeInUp 0.4s ease; }

                /* Order Type Tabs */
                .order-type-tabs {
                    display: flex; gap: 10px; flex-wrap: wrap;
                    margin-bottom: 18px;
                }
                .order-tab {
                    display: flex; align-items: center; gap: 8px;
                    padding: 9px 18px; border-radius: 50px;
                    border: 2px solid #eee;
                    background: #fff; cursor: pointer;
                    font-size: 13px; font-weight: 600;
                    transition: all 0.2s;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                }
                .order-tab:hover { transform: translateY(-2px); box-shadow: 0 4px 14px rgba(0,0,0,0.1); }
                .order-tab.active { color: #fff !important; border-color: transparent; }
                .order-tab .tab-count {
                    background: rgba(255,255,255,0.25);
                    padding: 1px 8px; border-radius: 20px;
                    font-size: 11px; font-weight: 700;
                }
                .order-tab:not(.active) .tab-count { background: #f0f0f0; color: #555; }

                /* Filter Card */
                .filter-card {
                    background: #fff;
                    border-radius: 16px;
                    padding: 18px 20px;
                    margin-bottom: 18px;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.06);
                    border: none;
                }
                .filter-card label {
                    font-size: 11px; font-weight: 600;
                    color: #888; text-transform: uppercase;
                    letter-spacing: 0.5px; margin-bottom: 5px;
                    display: block;
                }
                .filter-card .form-control {
                    border-radius: 10px; border: 1.5px solid #eee;
                    font-size: 13px; padding: 8px 12px;
                    transition: border-color 0.2s;
                }
                .filter-card .form-control:focus {
                    border-color: #4e9191;
                    box-shadow: 0 0 0 3px rgba(78,145,145,0.1);
                }

                /* Table Card */
                .orders-table-card {
                    background: #fff;
                    border-radius: 16px;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.06);
                    overflow: hidden;
                    border: none;
                }
                .orders-table-card table { margin: 0; }
                .orders-table-card thead th {
                    background: #f8f9fa;
                    font-size: 11px; font-weight: 700;
                    color: #666; text-transform: uppercase;
                    letter-spacing: 0.5px; padding: 13px 12px;
                    border-bottom: 2px solid #eee;
                    white-space: nowrap;
                }
                .orders-table-card tbody tr {
                    transition: background 0.15s;
                    border-bottom: 1px solid #f8f8f8;
                }
                .orders-table-card tbody tr:hover { background: #f8fffe; }
                .orders-table-card tbody td {
                    font-size: 13px; color: #444;
                    padding: 11px 12px; vertical-align: middle;
                    white-space: nowrap;
                }
                .orders-table-card tfoot th {
                    background: #f8f9fa;
                    font-size: 11px; font-weight: 700;
                    color: #888; padding: 11px 12px;
                    text-transform: uppercase; letter-spacing: 0.5px;
                }

                /* Status Badge */
                .status-badge {
                    display: inline-flex; align-items: center;
                    padding: 3px 10px; border-radius: 20px;
                    font-size: 11px; font-weight: 600;
                    white-space: nowrap;
                }

                /* Order number badge */
                .order-num {
                    font-size: 12px; font-weight: 700;
                    color: #4e9191; font-family: monospace;
                }

                /* Action buttons */
                .action-btn {
                    display: inline-flex; align-items: center;
                    justify-content: center;
                    width: 30px; height: 30px;
                    border-radius: 8px; margin: 0 2px;
                    transition: all 0.2s; text-decoration: none;
                }
                .action-btn:hover { transform: translateY(-2px); }
                .action-btn.track { background: #e3f2fd; color: #1565c0; }
                .action-btn.view  { background: #e8f5e9; color: #0e7c52; }

                /* Pagination */
                .round-pagination .page-item.actives .page-link {
                    background-color: #04152d !important;
                    border-color: #04152d !important;
                    color: #fff !important;
                    z-index: 1;
                    border-radius: 8px !important;
                }
                .round-pagination .page-item .page-link {
                    background-color: #fff;
                    border: 1.5px solid #eee;
                    color: #555;
                    border-radius: 8px !important;
                    margin: 0 2px;
                    font-size: 12px;
                    font-weight: 600;
                    padding: 5px 12px;
                    transition: all 0.2s;
                    box-shadow: none !important;
                }
                .round-pagination .page-item .page-link:hover {
                    background-color: #04152d !important;
                    border-color: #04152d !important;
                    color: #fff !important;
                    border-radius: 8px !important;
                }
                .round-pagination .page-item .page-link:focus {
                    box-shadow: none !important;
                    outline: none;
                }

                /* Summary bar */
                .summary-bar {
                    display: flex; align-items: center;
                    justify-content: space-between;
                    padding: 12px 20px;
                    border-bottom: 1px solid #f0f0f0;
                    background: #fafafa;
                }
                .summary-bar span { font-size: 13px; color: #666; font-weight: 500; }
                .summary-bar strong { color: #333; }
            `}</style>

            <ContentWrapper>
                <div className="order-page">

                    {/* Breadcrumb */}
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                                <li className="breadcrumb-item">All Orders</li>
                            </ol>
                        </nav>
                    </div>

                    {/* Order Type Tabs */}
                    <div className="order-type-tabs">
                        {ORDER_TYPES.map((type) => (
                            <div
                                key={type.key}
                                className={`order-tab ${activeType === type.key ? 'active' : ''}`}
                                style={activeType === type.key
                                    ? { background: type.color, color: '#fff' }
                                    : { color: type.color }
                                }
                                onClick={() => getAllCmsOrders(type.key)}
                            >
                                {type.icon}
                                {type.label}
                                <span className="tab-count">
                                    {totalCounts[type.key] ?? '—'}
                                </span>
                            </div>
                        ))}
                    </div>

                    {/* Filter Card */}
                    <div className="filter-card">
                        <form onSubmit={handleFilter} ref={ref}>
                            <div className="row g-2 align-items-end">
                                <div className="col-12 col-lg-2">
                                    <label>Search By Name</label>
                                    <input name="cname" className="form-control" type="text"
                                        placeholder="Customer name" onChange={handleInputs} />
                                </div>
                                <div className="col-12 col-lg-2">
                                    <label>Order Number</label>
                                    <input name="onumber" className="form-control" type="text"
                                        placeholder="Order number" onChange={handleInputs} />
                                </div>
                                <div className="col-12 col-lg-2">
                                    <label>Mobile Number</label>
                                    <input name="cmobile" className="form-control" type="text"
                                        placeholder="Mobile number" onChange={handleInputs} />
                                </div>
                                <div className="col-12 col-lg-2">
                                    <label>Vendor Name</label>
                                    <select name="vendor_name" className="form-control" onChange={handleInputs}>
                                        <option value="">All Vendors</option>
                                        {VENDOR_OPTIONS.map((vendor) => (
                                            <option key={vendor} value={vendor}>{vendor}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-12 col-lg-2">
                                    <label>Order Status</label>
                                    <select name="sstatus" className="form-control" onChange={handleInputs}>
                                        <option value="">All Statuses</option>
                                        {sstatus?.map((s, i) => (
                                            <option key={i} value={s?.status_name}>{s?.status_name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-12 col-lg-2">
                                    <label>Date From</label>
                                    <input name="date_from" className="form-control" type="date"
                                        onChange={handleInputs} />
                                </div>
                                <div className="col-12 col-lg-2">
                                    <label>Date To</label>
                                    <input name="date_to" className="form-control" type="date"
                                        onChange={handleInputs} />
                                </div>
                                <div className="col-12 col-lg-2">
                                    <div className="d-flex gap-2 align-items-center" style={{ paddingTop: '22px' }}>
                                        <button type="submit" className="btn btn-sm"
                                            style={{ background: '#4e9191', color: '#fff', borderRadius: '8px', fontWeight: 600, fontSize: '12px', padding: '7px 14px', whiteSpace: 'nowrap' }}>
                                            <FaFilter style={{ marginRight: '4px', fontSize: '10px' }} /> Filter
                                        </button>
                                        <button type="button" onClick={resetOrder} className="btn btn-sm"
                                            style={{ background: '#fff3cd', color: '#856404', borderRadius: '8px', fontWeight: 600, fontSize: '12px', padding: '7px 10px' }}>
                                            <FaRedo style={{ fontSize: '11px' }} />
                                        </button>
                                        <CsvDownloader filename="All Orders" extension=".csv" datas={cmsorder} columns={columns}>
                                            <button type="button" className="btn btn-sm"
                                                style={{ background: '#e3f2fd', color: '#1565c0', borderRadius: '8px', fontWeight: 600, fontSize: '12px', padding: '7px 10px' }}>
                                                <CiExport style={{ fontSize: '14px' }} />
                                            </button>
                                        </CsvDownloader>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    {/* Table */}
                    <div className="orders-table-card" style={{ marginBottom: "50px" }}>

                        {/* Summary Bar */}
                        <div className="summary-bar">
                            <span>
                                Showing <strong>{records.length}</strong> of <strong>{cmsorder.length}</strong> orders
                                {activeType !== 'all' && (
                                    <span style={{ marginLeft: '8px', color: '#4e9191', fontWeight: 600, textTransform: 'capitalize' }}>
                                        · {activeType}
                                    </span>
                                )}
                            </span>
                            <span>Page <strong>{currentPage}</strong> of <strong>{npage || 1}</strong></span>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Order No.</th>
                                        <th>AWB Number</th>
                                        <th>CRM Order No</th>
                                        <th>Name</th>
                                        <th>Mobile</th>
                                        <th>Price</th>
                                        <th>Order Date</th>
                                        <th>Order Time</th>
                                        <th>State</th>
                                        <th>City</th>
                                        <th>Pincode</th>
                                        <th>Vendor Name</th>
                                        <th>Order Type</th>
                                        <th>Status</th>
                                        <th>Payment Method</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading
                                        ? [...Array(10)].map((_, i) => <SkeletonRow key={i} />)
                                        : records.length === 0
                                            ? (
                                                <tr>
                                                    <td colSpan={17} className="text-center py-5">
                                                        <div style={{ color: '#bbb', fontSize: '14px' }}>
                                                            No orders found
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                            : records.map((record, index) => {
                                                const statusStyle = getStatusStyle(record?.shipment_status);
                                                return (
                                                    <tr key={index}>
                                                        <td style={{ color: '#aaa', fontSize: '12px' }}>
                                                            {firstIndex + index + 1}
                                                        </td>
                                                        <td>
                                                            <span className="order-num">#{record?.order_number}</span>
                                                        </td>
                                                        <td style={{ fontFamily: 'monospace', fontSize: '12px', color: '#888' }}>
                                                            {record?.awb_number || '—'}
                                                        </td>
                                                        <td>
                                                            <span style={{
                                                                color: '#1b9a69',
                                                                padding: '3px 10px', borderRadius: '20px',
                                                                fontSize: '11px', fontWeight: 600
                                                            }}>
                                                                {record?.crm_order_id || '—'}
                                                            </span>
                                                        </td>
                                                        <td style={{ fontWeight: 500 }}>{record?.cust_name}</td>
                                                        <td>{record?.cust_phone}</td>
                                                        <td style={{ fontWeight: 600, color: '#0e7c52' }}>
                                                            {numberFormat(record?.subtotal_price)}
                                                        </td>
                                                        <td>{record?.created_date}</td>
                                                        <td style={{ color: '#888' }}>{record?.created_time}</td>
                                                        <td>{record?.state}</td>
                                                        <td>{record?.city}</td>
                                                        <td>{record?.pincode}</td>
                                                        <td>{record?.vendor_name || 'â€”'}</td>
                                                        <td>
                                                            {(() => {
                                                                const cs = getConfirmStyle(record?.order_confirm_status);
                                                                return (
                                                                    <span style={{
                                                                        background: cs.bg, color: cs.color,
                                                                        padding: '3px 10px', borderRadius: '20px',
                                                                        fontSize: '11px', fontWeight: 600,
                                                                        display: 'inline-block'
                                                                    }}>
                                                                        {record?.order_confirm_status || '—'}
                                                                    </span>
                                                                );
                                                            })()}
                                                        </td>
                                                        <td>
                                                            <span className="status-badge" style={{
                                                                background: statusStyle.bg,
                                                                color: statusStyle.color
                                                            }}>
                                                                {record?.shipment_status || 'New'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span className="status-badge" style={{
                                                                background: statusStyle.bg,
                                                                color: statusStyle.color
                                                            }}>
                                                                {record?.payment_method || 'New'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <Link
                                                                style={{ cursor: "pointer" }}
                                                                to={`/order-detail/${record?.order_number || record?.order_id}`}
                                                                className="action-btn view">
                                                                <FaRegEye style={{ fontSize: '14px' }} />
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th>#</th>
                                        <th>Order No.</th>
                                        <th>AWB Number</th>
                                        <th>CRM Order No</th>
                                        <th>Name</th>
                                        <th>Mobile</th>
                                        <th>Price</th>
                                        <th>Order Date</th>
                                        <th>Order Time</th>
                                        <th>State</th>
                                        <th>City</th>
                                        <th>Pincode</th>
                                        <th>Vendor Name</th>
                                        <th>Order Type</th>
                                        <th>Status</th>
                                        <th>Payment Method</th>
                                        <th>Action</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                        {/* Pagination */}
                        <div className="d-flex justify-content-end p-3">
                            <nav>
                                <ul className="pagination round-pagination mb-0">
                                    <li className="page-item">
                                        <a href="#" className="page-link" onClick={(e) => { e.preventDefault(); perPage(); }}>← Prev</a>
                                    </li>
                                    {numbers.slice(
                                        Math.max(0, currentPage - 2),
                                        Math.max(5, currentPage + 3)
                                    ).map((n, i) => (
                                        <li key={i} className={`page-item ${currentPage === n ? 'actives' : ''}`}>
                                            <a href="#" className="page-link"
                                                onClick={(e) => { e.preventDefault(); changePage(n); }}>{n}</a>
                                        </li>
                                    ))}
                                    <li className="page-item">
                                        <a href="#" className="page-link" onClick={(e) => { e.preventDefault(); nextPage(); }}>Next →</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    );

    function perPage() { if (currentPage !== 1) setCurrentPage(currentPage - 1); }
    function changePage(id) { setCurrentPage(id); }
    function nextPage() { if (currentPage !== npage) setCurrentPage(currentPage + 1); }
};

export default withAuth(AllOrders);
